import React from 'react';

export interface PageTab<K extends string> {
  key: K;
  label: string;
}

/** Underlined page-level tabs (ARIA tablist; panels are rendered by the page). */
export default function PageTabs<K extends string>({
  tabs,
  active,
  onChange,
  label
}: {
  tabs: ReadonlyArray<PageTab<K>>;
  active: K;
  onChange: (key: K) => void;
  label: string;
}) {
  return (
    <div className="page-tabs" role="tablist" aria-label={label}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          role="tab"
          id={`tab-${tab.key}`}
          aria-selected={active === tab.key}
          aria-controls={`tabpanel-${tab.key}`}
          className={'page-tab' + (active === tab.key ? ' on' : '')}
          onClick={() => onChange(tab.key)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
